import { Box, FormControl, Grid, MenuItem, Select, Tooltip } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import { serviceProvider } from "../../provider/serviceProvider";
import DataGridTable from "../DataGridTable/DataGridTable";
import { getFormattedDate } from "../../utility/formateDateAndTime";
import SearchBar from "../searchBar/SearchBar";

const columns = [


  {
    field: "email",
    headerName: "Email",
    width: 200,
    editable: false,
    renderCell: (params: any) => {
      return (
        <Tooltip title={params.row?.email}>
          <span>{params.row?.email}</span>
        </Tooltip>
      );
    },
  },
  {
    field: "name",
    headerName: "Full Name",
    width: 250,
    editable: false,
    renderCell: (params: any) => {
      return (
        <Tooltip title={params.row?.name}>
          <span>{params.row?.name}</span>
        </Tooltip>
      );
    },
  },
  {
    field: "mobileNumber",
    headerName: "Mobile No.",
    width: 200,
    editable: false,
    renderCell: (params: any) => {
      return (
        <Tooltip title={params.row?.mobileNumber}>
          <span>{params.row?.mobileNumber}</span>
        </Tooltip>
      );
    },
  },

  {
    field: "route",
    headerName: "Preferred Route",
    width: 700,
    editable: false,
    renderCell: (params: any) => {
      return (
        <Tooltip title={params.row?.route}>
          <span>{params.row?.route}</span>
        </Tooltip>
      );
    },
  },
  {
    field: "recordCreatedTs",
    headerName: "Generated On",
    width: 300,
    valueGetter: (params) => {
      const date = new Date(params.row.recordCreatedTs);
      return date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata" });
    },
  },
];
const EmptyLegQuery = () => {
  const [pageState, setPageState] = React.useState({
    loader: false,
    data: [],
    totalPages: 0,
    page: 0,
    pageSize: 5,
  });

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [orderValue, setOrderValue] = useState<string>("recordCreatedTs.desc");

  const handleOrderChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setOrderValue(event.target.value);
  };
  
  const orderOptions = [
    { key: "Newest first", value: "recordCreatedTs.desc"  },
    { key: "Oldest first", value: "recordCreatedTs.asc" },
  ];

  const getEmptyLegQueries = (param: any) => {
    setPageState((prev) => ({ ...prev, loader: true }));

    serviceProvider.emptyLegService
      .get(param)
      .then((res: any) => {
        if (res.responseCode === 200) {
          setPageState((prev) => ({
            ...prev,
            loader: false,
            data: res.data.data,
            totalPages: res.data.totalRecordCount,
          }));
        }
        setPageState((prev) => ({ ...prev, loader: false }));
      })
      .catch((err) => {
        setPageState((prev) => ({ ...prev, loader: false }));
        console.log({ err });
      });
  };

  const rows = pageState?.data?.map((query: any, index: any) => ({
    ...query,
    id: query.emptyLegEnquiryId,
    recordCreatedTs : query.recordCreatedTs
  }));



  useEffect(() => {
    const param = `enquiry/search?email=${searchQuery}&offset=${pageState.page}&limit=${pageState.pageSize}&order=${orderValue}`
    getEmptyLegQueries(param)
}, [pageState.page, pageState.pageSize,searchQuery,orderValue]);

  return (
   <>

    <Grid container rowSpacing={2}>
      <Grid
        item
        xs={12}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
         <Grid item xs={7} md={7}>
                      <SearchBar 
                      value={searchQuery}
                      onChange={(e:any)=>setSearchQuery(e.target.value)}
                      placeholder="Search by email" />
                    </Grid>
                    <Grid item display='flex' flexDirection='row' alignItems='center' gap="10px">
                        Sort By
                    <Box
                            sx={{
                                borderRadius: "20px",
                                backgroundColor:'rgba(255, 255, 255, 1)',
                                boxShadow:'0 2px 2px 0 rgba(0, 0, 0, 0.25)'
                            }}
                        >
                    <FormControl fullWidth>
                                <Select
                                    sx={{ padding: "0 10px" }} 
                                    value={orderValue}
                                    // name={name}
                                    slotProps={{
                                        input: {
                                            id: "",
                                        },
                                    }}
                                    // id={id}
                                    variant="standard"
                                    disableUnderline
                                    onChange={(e:any)=>handleOrderChange(e)}
                                >
                                    {orderOptions?.map((option: any) => {
            return <MenuItem value={option.value}>{option.key}</MenuItem>;
          })}
                                </Select>
                            </FormControl>
                            </Box>
                    </Grid>
      </Grid>
      <Grid item xs={12}>
        <DataGridTable
          pageState={pageState}
          setPageState={setPageState}
          rows={rows}
          columns={columns}
        />
    
      </Grid>
    </Grid>
   </>
  );
};

export default EmptyLegQuery;
